import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Observable, map, withLatestFrom } from "rxjs";
import { v4 } from "uuid";

import { CtaSize, LARGE } from "@hermes/aphrodite/call-to-action";
import { Context } from "@hermes/app-core";
import { ConfigMessageError } from "@hermes/fragments/product-utils";
import { AddToCartFacade } from "@hermes/states/add-to-cart";
export const DEFAULT_ADD_TO_CART_ERROR: ConfigMessageError = {
    type: "info",
    translation: "",
    enabled: false,
    showBackground: false,
};
/**
 * Component to manage call to action add-to-cart button
 */
@Component({
    selector: "h-call-to-action-add-to-cart",
    templateUrl: "./call-to-action-add-to-cart.component.html",
    styleUrls: ["./call-to-action-add-to-cart.component.scss"],
})
export class CallToActionAddToCartComponent implements OnInit {
    @Input()
    public isloading = false;

    @Input()
    public positions = [0];

    @Input()
    public size: CtaSize = LARGE;

    /**
     * Manage error of add to cart
     */
    @Input()
    public addToCartError: ConfigMessageError = DEFAULT_ADD_TO_CART_ERROR;

    // Output

    @Output()
    public addToCart: EventEmitter<void> = new EventEmitter<void>();

    public addToCartButtonEnabled$!: Observable<boolean>;

    public isLoadingAddToCart$: Observable<boolean> =
        this.addToCartFacade.isAddToCartLoading$.pipe(
            withLatestFrom(this.addToCartFacade.addToCartPositionClicked$),
            map(
                ([isAddToCartLoading, addToCartPositionClicked]) =>
                    isAddToCartLoading &&
                    addToCartPositionClicked === this.positions[0],
            ),
        );

    /**
     * use to set 'add to cart' button state loading in SSR mode
     */
    public formLoaded: boolean = false;

    /**
     * Used to randomize the button ids when several ATC are on the same page (look)
     */
    public idSuffix = v4();

    constructor(
        private context: Context,
        private addToCartFacade: AddToCartFacade,
    ) {}

    public ngOnInit(): void {
        /**
         * disable loading 'add to cart' button in browser mode, when page is loaded
         */
        if (this.context.isInBrowserMode()) {
            this.formLoaded = true;
        }

        this.addToCartButtonEnabled$ =
            this.addToCartFacade.isAddToCartButtonEnabled(this.positions);
    }
}
